export default __webpack_public_path__ + "static/media/news_post.518d8529.png";